import React, { Component, useEffect } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import Axios from 'axios'
import { URLSVC } from 'src/config/helper/urlService'
import Swal from 'sweetalert2'
import './scss/style.scss';
import { useIdleTimer } from 'react-idle-timer'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const progressBar = (
    <div id="loading" style={{display:'block', backgroundColor:'#3c4b64', position:'absolute', width:'100%',height:'100%'}}>
        <div style={{marginTop:'210px'}}><center><img src={'avatars/loading.gif'} width="150px" alt="Loading..." /></center></div>
        <div style={{marginTop:'-20px'}}><center><b><font color="white">Sedang memuat, harap menunggu...</font></b></center></div>
    </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Tv = React.lazy(() => import('./views/pages/tv/Tv'));

const App = () => {
  var TOKEN = localStorage.getItem('TOKEN');
  useEffect(() => {
    GetInfoUser()
    // if(TOKEN == null)
    //   window.location.replace('/#/login')

    console.log('window.location.pathname', window.location.pathname)
    if (!(window.location.pathname).includes("admin")) {
      window.location.replace("/admin"+window.location.pathname)
    } else if(window.location.pathname == "/admin"){
      window.location.replace(window.location.pathname+"/")
    }
  }, [])

  const GetInfoUser = () => {
    Axios.get(`${URLSVC}/Webs/GetInfoUser`, { headers: { 'Authorization': 'Bearer ' + TOKEN } }).then(res => {
      let data = res.data;
      if (data.IsSuccess) {
        localStorage.setItem('SessionLogin',JSON.stringify(data.Data));
        console.log(data.Data)
      } else {
        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
      }
    }).catch(err => {
      // if (err.response.status == 401) {
      //   localStorage.removeItem('TOKEN');
      // } else {
      //   Swal.fire('Terjadi Kesalahan', `${JSON.stringify(err.message)}`, 'error')
      // }
    })
  }

  /// handle activity on idle ////
  const logout = () => {
    localStorage.removeItem('TOKEN')
    window.location = '/admin/'
  }

  const handleOnIdle = event => {
    if(TOKEN != null){
      logout()
    } 
    
    console.log('user is idle', event)
    console.log('last active', getLastActiveTime())
  }

  const handleOnActive = event => {
    console.log('user is active', event)
    console.log('time remaining', getRemainingTime())
  }

  const handleOnAction = event => {
    //console.log('user did something', event)
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 5,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  })
  /// handle idle activity ////

  return (
    <BrowserRouter basename='admin'>
        <React.Suspense fallback={progressBar}>
          <Switch>
          <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
          <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
          <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
          <Route exact path="/Tv" name="Tv" render={props => <Tv {...props} />} />
          {
            TOKEN != null ? (
              <>
                <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
                <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
              </>
              ) : 
              <>
                <Route path="/" name="Login Page" render={props => <Login {...props}/>} />
              </>
          }
          </Switch>
        </React.Suspense>
    </BrowserRouter>
  );
}

export default App;
